import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportFiltersMobilePage } from './report-filters-mobile.page';

const routes: Routes = [
  {
    path: '',
    component: ReportFiltersMobilePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportFiltersMobilePageRoutingModule {}
